// *页面name  不要随意更改 有地方用来做判断了
import i18n from '@/i18n/locale';

export default [
  {
    path: '/pay-success',
    name: 'PaySuccess',
    meta: {
      title: i18n.t('sailing.launcher-xtx-center.支付成功'),
    },
    component: () => import('@/views/PaySuccess.vue'),
  },
];
